import { NgModule } from '@angular/core';

import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';

import { FieldSharedModule } from 'app/field-shared/field-shared.module';
import { EntityCoreModule } from 'entity/entity-core.module';
import { SharedModule } from 'shared/shared.module';

import {
  DateRangeAndUsersQueryLinkComponent
} from './components/date-range-and-users-query-link/date-range-and-users-query-link.component';
import {
  DateTagRangeQueryInputComponent
} from './components/date-tag-range-query-input/date-tag-range-query-input.component';
import {
  EntityConnectionSubqueryInputComponent
} from './components/entity-connection-subquery-input/entity-connection-subquery-input.component';
import {
  IncludeExcludeHavingToggleComponent
} from './components/include-exclude-having-toggle/include-exclude-having-toggle.component';
import {
  TagsAdvancedRuleInputComponent
} from './components/tags-advanced-rule-input/tags-advanced-rule-input.component';
import {
  FieldsAdvancedRuleInputComponent
} from './components/fields-advanced-rule-input/fields-advanced-rule-input.component';
import { DateRangeUsersOperatorDialog } from './dialogs/date-range-users-operator/date-range-users-operator.dialog';
import { ConnectionMatchingOperatorDialog } from './dialogs/connection-matching-operator/connection-matching-operator.dialog';
import { TagsAdvancedComboInputComponent } from './components/tags-advanced-combo/tags-advanced-combo.component';
import { FieldsAdvancedComboInputComponent } from './components/fields-advanced-combo/fields-advanced-combo.component';
import { NameQueryFieldInputComponent } from 'app/query-common/components/name-query-field-input/name-query-field-input.component';
import { FollowUpFlagQueryPresenterComponent } from 'app/query-common/components/follow-up-flag-query-input/follow-up-flag-query-presenter.component';

const DIALOGS = [
  DateRangeUsersOperatorDialog,
  ConnectionMatchingOperatorDialog
];

const COMPONENTS = [
  NameQueryFieldInputComponent,
  TagsAdvancedRuleInputComponent,
  TagsAdvancedComboInputComponent,
  FieldsAdvancedRuleInputComponent,
  FieldsAdvancedComboInputComponent,
  DateRangeAndUsersQueryLinkComponent,
  DateTagRangeQueryInputComponent,
  EntityConnectionSubqueryInputComponent,
  IncludeExcludeHavingToggleComponent,
  FollowUpFlagQueryPresenterComponent
];

/**
 * This module is for components that are used in both simple query builders.
 * and in advanced query builder (filter groups)
 */
@NgModule({
  imports: [
    SharedModule,
    FieldSharedModule,
    EntityCoreModule,
    NgxAngularQueryBuilderModule
  ],
  declarations: [
    ...COMPONENTS,
    ...DIALOGS
  ],
  exports: [
    ...COMPONENTS,
    ...DIALOGS
  ],
  providers: [
  ]
})
export class QueryCommonModule { }
